/**
 * @module SessionStorageHelpers
 * @name Session Storage Helpers
 *
 * @description
 * Common helpers for setting and getting keys from session Storage
 *
 */

/**
 * Sets stringified value against key in session storage.
 * @param {String} key - Key to set in session storage
 * @param {any} value - Value to set for Key
 */
const setKey = (key, value) =>
	sessionStorage.setItem(key, JSON.stringify(value));

/**
 * Get key from session storage.
 * @param {String} key - Key to fetch from storage
 * @param {any} [returnIfNotPresent=null] - Value to return if not found in storage
 * @return {any}
 */
const getKey = (key, returnIfNotPresent = null) => {
	const fetched = sessionStorage.getItem(key);
	if (fetched) {
		return JSON.parse(fetched);
	}
	return returnIfNotPresent;
};

export { getKey, setKey };
